import { render, staticRenderFns } from "./OrderDetailQuantity.vue?vue&type=template&id=669b1b5a"
import script from "./OrderDetailQuantity.vue?vue&type=script&lang=js"
export * from "./OrderDetailQuantity.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailQuantity.vue?vue&type=style&index=0&id=669b1b5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports